import React, { Component } from "react";
import "./home.css";
import Project from "./components/Project.js";
import NavBar from "./components/NavBar.js";

class Projects extends Component {
  state = {
    projects: [
      {
        name: "Scrapbook Travel Photobook App in React and Node",
        blurb: "MIT Weblab Web dev competition IAP 2021",
        videoLink: "https://www.youtube.com/embed/9F4QZQ422pg",
        bullets: [
          "Languages used: ReactJS, Node.js, HTML/CSS, JavaScript",
          "Technologies used: MongoDB (database), Google Cloud (storing images)",
          "Designed the backend and UI for a travel app in 2 weeks that allows users to create posts with captions, photos, and optional stamp/background colors within each chapter/trip along with its location to be displayed on the map tab for other users to see using react libraries.",
          "Implemented the backend user/page/chapter schemas and API calls for creating/deleting chapters and pages, updating user bio/profile pic in Node.js to the MongoDB database, and storing the images in Google Cloud",
          "Programmed the frontend for the scrapbook UI/UX (posts, chapters, comments, likes), map tooltip with hover feature for displaying chapters on the interactive map, profile update, and animated homepage.",
        ],
        reportLink: "https://tagg-it.herokuapp.com/",
      },
      {
        name: "Multiplayer Crossword Puzzle in Java/Java Swing GUI",
        blurb:
          "Client Java Swing GUI designed and implemented mainly by Karen Gao with some refactoring assistance from Daniel Barnett",
        videoLink: "https://www.youtube.com/embed/XZ-P0QUQFrc",
        bullets: [
          "Implemented a client and UI for a multiplayer crossword game on the server at port 4949 that allows for fill, erase, check, and concurrency using live update (watch method/callback functions) on the server.",
          "Designed a client-server wire protocol in regex grammar, specs for the crossword ADT that stores game state, and multi-threaded tests for the server to handle concurrent requests like look, erase, get list of games, and watch, that returns the current board state along with the players in it once there’s been a change.",
          "server handles requests like /look/gameID/playerID, /erase/gameID/playerID/direction/r,c, /getgames/ and /watch/gameID/playerID ",
        ],
        reportLink: "https://app.luminpdf.com/viewer/5ecd5e7de6cf1e0013140fff",
      },
      {
        name:
          "Bluffalo: An Embedded Systems Multiplayer Web Server Party Game in C++",
        blurb:
          "A 3-round bluffing multiplayer party game supporting up to six players connected to a shared web server. ",
        videoLink: "https://www.youtube.com/embed/5p--cW7tbzc",
        bullets: [
          "A bluffing multiplayer party game supporting up to six players connected to a shared web server where each submits bluffs and votes for their favorite on their local ESP32 using a button-tilt mechanism, which are then communicated to the website platform (in JavaScript) via a SQL database",
          "Players use their ESP to enter a word that they believe legitimate. If a player happens to enter the correct answer, they are informed of this and encourage do enter a false answer",
          "Shared server presents all players' answers as well as the correct answer.",
          "Players select the answer they believe to be correct. A player scores points by selecting the correct answer, or by having other players select their fake answer",
        ],
        reportLink:
          "https://77852924-612b-428c-b57a-87d235a9c84c.filesusr.com/ugd/0dbcab_07aa8631f303433abae0153182564793.pdf",
      },
      {
        name:
          "Embedded Systems Project: Shopping Tracker in C++ using ESP32 and SQLite",
        blurb:
          "Keeps track of items in shopping cart and displays current tally with each addition of items.  ",
        videoLink: "https://www.youtube.com/embed/id3y8XiklGY",
        bullets: [
          "Uses POST requests to add new items to our online server database and get a response of all items so far along with total price for the cart.",
          ,
          "Device that acts as a mobile shopping cart tracker that the shopper can use to add groceries to their cart and display the current tally along with the cart's current total price. Built using an ESP32, a button, LCD Screen. Programmed using Arduino/C++.",
          ,
          "User is able to specify the quantity of each grocery item added",
          "The system communicates with a server-side script including a database that keeps track of the current shopping tally for the user",
          "The user is able to check-out/reset the system",
        ],
        reportLink:
          "https://docs.google.com/document/d/187Gm7zrFp8fLUNfKwY56FtPZSbvyh5bhOEinFwoBXwk/edit?usp=sharing",
      },

      {
        name:
          "Embedded Systems Project: Motion Monitor in C++ using ESP32 and Phototransistors",
        blurb:
          "Detects objects within a few inches of the phototransistors and senses right to left/left to right motion and its speed in inches per second. ",
        videoLink: "https://www.youtube.com/embed/rIy8YzcoGM0",
        bullets: [
          "The two phototransistors that comprise this motion detector circuit system should be able to detect objects placed a few inches above it.",
          "Also detects right to left or left to right motions and its corresponding speed estimation in inches per second.",
          "LCD screen displays a speed estimation of the most recently completed left-to-right or right-to-left motion.",
          "The motion-sensing system has an auto-calibration procedure at the start to collect ambient light settings to detect future relative motions.",
        ],
        reportLink:
          "https://docs.google.com/document/d/1Iv2Dtsuaz1YRD6jTxBw2_D-apkHazZSRQvMWliAjE58/edit?usp=sharing",
      },

      {
        name:
          "Embedded Systems Project: Clapper in C++ using ESP32 and a Microphone",
        blurb:
          "uses a microphone to sense loud claps. The screen turns GREEN or RED in response to two consecutive loud claps spaced around 0.5 seconds apart",
        videoLink: "https://www.youtube.com/embed/izN93U9vCRk",
        bullets: [
          "A clap-clap turns the screen on (turns green) and another clap-clap turns the screen off (turns red).",
          "A clap-clap is a series of two claps spaced around 0.5 seconds apart (less than a second and more than 0.25 seconds from the previous clap).",
          "The system is able to distinguish loud claps from loud continuous background noises.",
          "Only responds to “clap-claps” or a series of two quick claps, not three, four, or more",
        ],
        reportLink:
          "https://docs.google.com/document/d/1mUZ2NnspOJERjIcV_20NIxxqxGEUh_NfEDO5-TDqdA0/edit?usp=sharing",
      },

      {
        name:
          "Embedded Systems Project: Analog/Digital Watch in C++ using ESP32",
        blurb:
          "Programmed this digital/analog watch in arduino using and ESP, an LCD display screen, and a switch. ",
        videoLink: "https://www.youtube.com/embed/CNfpJcoD5sE",
        bullets: [
          "Get's current time around every minute from an url.",
          "uses an internal timer to update the time in between each GET request",
          "Upon the press of the button, the LCD changes from analog to digital or vice versa depending on the previous display state of the watch",
          "done through a state machine where there are three states: 'IDLE', 'UP', or 'DOWN' to denote which state the button is in.",
          "To keep track of which state to switch to when the button becomes pressed, we have a global int called num_pressed to keep track of the total number of times the button has been pressed. If num_pressed is even, display analog and if odd, display digital instead.",
        ],
        reportLink:
          "https://docs.google.com/document/d/1P7H9yZPnDqvW3-GdSIk60RQvhUY1b320oBXL_RPEiYA/edit?usp=sharing",
      },
    ],
  };
  render() {
    const { projects } = this.state;
    return (
      <body>
        <NavBar active="projects" />
        <div className="bodyProjects">
          <h1 class="name">Projects</h1>
          <div>
            {projects.map((project) => (
              <Project
                name={project.name}
                blurb={project.blurb}
                videoLink={project.videoLink}
                bullets={project.bullets.map((bullet, index) => (
                  <div key={index} className="bullet">
                    {bullet}
                  </div>
                ))}
                reportLink={project.reportLink}
              />
            ))}
          </div>
        </div>
      </body>
    );
  }
}

export default Projects;
